import { uniqueId } from 'lodash-es';
import Tracking from '~/tracking';
import SimpleCopyButton from '~/vue_shared/components/simple_copy_button.vue';
export default {
    name: 'CodeInstruction',
    components: {
        SimpleCopyButton
    },
    mixins: [
        Tracking.mixin()
    ],
    props: {
        label: {
            type: String,
            required: false,
            default: ''
        },
        instruction: {
            type: String,
            required: true
        },
        copyText: {
            type: String,
            required: true
        },
        multiline: {
            type: Boolean,
            required: false,
            default: false
        },
        trackingAction: {
            type: String,
            required: false,
            default: ''
        },
        trackingLabel: {
            type: String,
            required: false,
            default: ''
        }
    },
    created () {
        this.uniqueId = uniqueId();
    },
    methods: {
        trackCopy () {
            if (this.trackingAction) {
                this.track(this.trackingAction, {
                    label: this.trackingLabel
                });
            }
        },
        generateFormId (name) {
            return `${name}_${this.uniqueId}`;
        }
    }
};
